import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    comparisonTeaserData,
    TeaserComparison,
} from "../teaser/comparison/teaser-comparison.templates";
import { pageStoryDecorator } from "../../../shared/page";

export default {
    title: "Website/Partial Templates/Series-Comparison",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    decorators: [pageStoryDecorator],
};

/* TODO: replace PL background image */
const template = (left: boolean, background: string, secondButton: boolean) => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row">
                <div class="ux-col-12">
                    <div
                        class="ux-iws-teaser-comparison__background comparison-lower ${background}"
                    >
                        <div
                            class="ux-row ${left
                                ? "ux-u-flex-dir-row-reverse ux-u-flex-jc-end"
                                : ""}"
                        >
                            <div
                                class="ux-col-10 ux-col-lg-4 ux-u-offset-1 ux-u-offset-xl-1"
                            >
                                <div
                                    class="ux-iws-teaser-comparison__text-block"
                                >
                                    <h3
                                        class="ux-iws-teaser-comparison__text-block__title"
                                    >
                                        Test Headline
                                    </h3>
                                    <p>
                                        Lorem ipsum dolor sit amet, consetetur
                                        sadipscing elitr, sed diam nonumy eirmod
                                        tempor invidunt ut labore et dolore
                                        magna aliquyam erat, sed diam voluptua.
                                        At vero eos et accusam et justo duo
                                        dolores et ea rebum.
                                    </p>
                                    <div>
                                        <a
                                            href="#"
                                            class="ux-button ux-button--primary"
                                            >More Info</a
                                        >
                                        ${secondButton
                                            ? html`<a href="#" class="ux-button"
                                                  >Secondary</a
                                              >`
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <div
                                class="ux-col-11 ux-col-lg-5 ux-col-xl-4 ux-u-offset-1 ${left
                                    ? "ux-u-offset-xl-2"
                                    : ""}"
                            >
                                <ux-slider
                                    class="ux-u-margin-top-20"
                                    effect="cards"
                                >
                                    <ux-slider-slide>
                                        ${TeaserComparison(
                                            comparisonTeaserData,
                                            ""
                                        )}
                                    </ux-slider-slide>
                                    <ux-slider-slide>
                                        ${TeaserComparison(
                                            comparisonTeaserData,
                                            ""
                                        )}
                                    </ux-slider-slide>
                                    <ux-slider-slide>
                                        ${TeaserComparison(
                                            comparisonTeaserData,
                                            ""
                                        )}
                                    </ux-slider-slide>
                                    <ux-slider-slide>
                                        ${TeaserComparison(
                                            comparisonTeaserData,
                                            ""
                                        )}
                                    </ux-slider-slide>
                                </ux-slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
export const SeriesComparisonSlider = () =>
    template(false, "background1", false);
SeriesComparisonSlider.storyName = "Series Comparison Slider";

export const SeriesComparisonSliderLeft = () =>
    template(true, "background1", false);
SeriesComparisonSliderLeft.storyName = "Series Comparison Slider Left";

export const SeriesComparisonSliderDark = () =>
    template(false, "background3", true);
SeriesComparisonSliderDark.storyName = "Series Comparison Slider Dark";
